type MenuItemType = 'side-nav' | 'tabbed' | 'action';

export const getMenuItemTestId = (prefix: MenuItemType, menuItemLabel: string): string => {
  return `${prefix}-menu-${menuItemLabel.toLowerCase().replaceAll(' ', '-')}`;
};
